import { BaseApiService } from "./BaseApiService";
import { IPaginateApiResponse } from "model/Common/IPaginateApiResponse";
import { PREFIX } from "utils/Const";
import { IPaginationRequest } from "model/Common/IPaginationRequest";
import { IReceiveDocument } from "model/IReceive/IReceive";
import { IImportPalletDetail } from "model/IReceive/IImportPalletDetail";
import {
  IApiResponse,
  IDeleteByIdRequest,
  IGetByIdRequest,
  IGetReceiveDetailRequest,
  IReceiveDetail,
  IImportReceiveDocumentRequest,
  IUpdateReceiveDocument,
} from "model";

const prefix = PREFIX.receive;
const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};
const URL_GET_ALL_RECEIVE = getUrl("get-receive-document");
const URL_GET_RECEIVE_DOCUMENT_BY_ID = getUrl("get-receive-document-by-id");
const URL_GET_RECEIVE_DOCUMENT_DETAIL = getUrl("get-receive-document-detail");
const URL_GET_IMPORT_PALLET_DETAIL = getUrl(
  "get-receive-document-detail-split-by-document"
);
const URL_UPDATE_RECEIVE_DOCUMENT = getUrl("update-receive-document");
const URL_DELETE_RECEIVE_DOCUMENT = getUrl("delete-receive-document");
const URL_IMPORT_RECEIVE_DOCUMENT = getUrl("import-receive-document");

class ReceiveApiService extends BaseApiService {
  public getAllReceives = (request: IPaginationRequest) =>
    this.get<IPaginateApiResponse<IReceiveDocument[]>>(URL_GET_ALL_RECEIVE, {
      params: request,
    });
  public getReceiveDocumentById = (request: IGetByIdRequest) =>
    this.get<IApiResponse<IReceiveDocument>>(URL_GET_RECEIVE_DOCUMENT_BY_ID, {
      params: request,
    });
  public getReceiveDetail = (request: IGetReceiveDetailRequest) =>
    this.get<IPaginateApiResponse<IReceiveDetail[]>>(
      URL_GET_RECEIVE_DOCUMENT_DETAIL,
      {
        params: request,
      }
    );
  public getImportPalletDetail = (request: IGetReceiveDetailRequest) =>
    this.get<IPaginateApiResponse<IImportPalletDetail[]>>(
      URL_GET_IMPORT_PALLET_DETAIL,
      {
        params: request,
      }
    );
  public updateReceiveDocument = (request: IUpdateReceiveDocument) =>
    this.put<IUpdateReceiveDocument, IApiResponse<IReceiveDocument>>(
      URL_UPDATE_RECEIVE_DOCUMENT,
      request
    );
  public deleteReceiveDocument = (request: IDeleteByIdRequest) =>
    this.delete<any>(URL_DELETE_RECEIVE_DOCUMENT, {
      params: request,
    });
  public importReceiveDocument = (request: IImportReceiveDocumentRequest) =>
    this.postForm<any>(URL_IMPORT_RECEIVE_DOCUMENT, request, {
      params: {
        stockReceivingHeaderId: request.stockReceivingHeaderId,
      },
    });
}

export default new ReceiveApiService(true);
